import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/')({
    loader: async () => {
        throw redirect({
            to: '/leaderboard',
            replace: true,
        });
    },
    component: () => null,
});
